import styled, { css, keyframes } from 'styled-components';

const BounceInput = keyframes`
 0% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
  37% {
    transform: translateX(14px);
    timing-function: ease-out;
  }
  55% {
    transform: translateX(-14px);
    timing-function: ease-in;
  }
  73% {
    transform: translateX(14px);
    timing-function: ease-out;
  }
  82% {
    transform: translateX(-14px);
    timing-function: ease-in;
  }
  91% {
    transform: translateX(14px);
    timing-function: ease-out;
  }
  96% {
    transform: translateX(-14px);
    timing-function: ease-in;
  }
  100% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
`;

export const SkipDialogueItemWrap = styled.div`
  text-align: center;
  padding-top: 25px;
`;

export const SkipDialogueItem = styled.div``;

export const SkipDialogueTitle = styled.div`
  & > h1 {
    color: #000000;
    font-family: 'MontserratRegular',Arial;
    font-size: 16.0pt;
    line-height: 25px;
    font-weight: bold;
  }
  & > p {
    color: #000000;
    font-family: 'Montserrat',Arial;
    font-size: 10.0pt;
    font-style: normal;
    font-weight: 200;
  }
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const MainContext = styled.div`
  padding: 20px 20px;
  color: #000000;
  font-family: 'Montserrat',Arial;
  font-size: 10.0pt;
  font-style: normal;
  font-weight: 200;
  ${({ isLeft }) => isLeft && css`
    text-align: left;
`};
`;

export const ImageWrapper = styled.div`
  text-align: center;
`;

export const CourseManagementImageWrapper = styled.img`
  height: 47px;
  width: 95px;
  box-shadow: none;
`;

export const SectionCodeImageWrapper = styled.img`
  height: 64px;
  width: 137px;
  box-shadow: none;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonStyled = styled.button`
  width: 60%;
  min-height: 50px;
  margin: 30px 0;
  color: ${(props) => props.theme.colorStyled.ColorWhite};
  border: 1px solid #6ACA6B;
  background-color: #6ACA6B;
  font-family: 'Montserrat-Regular',Arial;
  font-size: 10.0pt;
  outline: none;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colorStyled.ColorWhite};
    border-color: #5E5E5E;
    background-color: #5E5E5E;
  }
  @media (max-width: 1440px) {
    padding: 10px 60px;
  }
  @media (max-width: 480px) {
    padding: 10px 20px;
  }
`;

export const BoldText = styled.span`
  font-weight: bold;
`;
